import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { SelectRetailer } from '../../../../common/components/SelectRetailer';
import { REAL_TIME_RETAILER_IDS } from '../../../../common/constants';
import { BasicDetailsFormData } from './types';

export function RetailerSelect() {
  const { control, getValues, setValue } = useFormContext<BasicDetailsFormData>();

  return (
    <Controller
      control={control}
      name="retailer"
      render={({ field: { onChange, onBlur, value, ref } }) => (
        <SelectRetailer
          ref={ref}
          onChange={(e) => {
            const existingTariffTypeValue = getValues('tariffType');
            // The tariff type select component doesn't support choosing real-time rates, because there are only some
            // specific retailers which support this structure.
            // If a user has already selected a real-time tariff and attempts to select a different retailer which does
            // not support real-time tariffs, automatically revert the tariff type.
            if (
              existingTariffTypeValue === 'REAL_TIME' &&
              REAL_TIME_RETAILER_IDS.includes(value.value) &&
              e &&
              !REAL_TIME_RETAILER_IDS.includes(e.value)
            ) {
              setValue('tariffType', 'FLAT');
            }
            onChange(e);
          }}
          onBlur={onBlur}
          value={value?.value ?? null}
        />
      )}
    />
  );
}
